import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=9abe1c84&scoped=true"
import script from "./productDialog.vue?vue&type=script&lang=js"
export * from "./productDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abe1c84",
  null
  
)

export default component.exports